export const BicSwiftRegexp = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export const IbanRegexp = /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/;

export const EmailRegexp =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const NameRegexp = /^(?=[a-zA-Za-åa-ö-w-яА-ЩЬЮЯҐЄІЇа-щьюяґєії0-9!@#$%&*)(+=._ \-']{2,50}$)(?!.*[_.]{2})[^_.].*[^_.]$/;

export const TaxRegexp = /^[A-Z0-9-.]{4,18}$/;

export const ZipRegexp = /^[a-zA-Z0-9][A-Za-z0-9\- ]{4,10}$/;
